<div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
    <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
        <div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
            <div class="subscription-registration aem-GridColumn aem-GridColumn--default--12 subscription-registration-wrapper">
                <ng-container *ngIf="!isPlanLoaded">
                    <div class="loading-spinner">
                        <div alt="Loading..." class="small progress">
                            <div class="prog1">
                                <div class="prog2"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <app-snap-eligiblity *ngIf="isPlanLoaded" [plansResponse]="plansResponse" [userInfo]="userInfo"></app-snap-eligiblity>
            </div>
            <div *ngIf="showEasyStepsComponent" class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
                <div class="container p0 clear-fix mb48" role="region">
                    <div
                      [innerHTML]="easyStepsComponent | safeHtml">
                    </div>
                </div>
            </div>


            <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
                <div class="container p0 clear-fix mb48" role="region">
                    <div *ngIf="snapBenefitsJSON">
                        <snap-freshpass-benefits
                                [currentEnvironment]="currentEnvironment"
                                [snapBenefitsJSON]="snapBenefitsJSON">
                        </snap-freshpass-benefits>
                    </div>
                </div>
            </div>

            <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
                <div class="column-control aem-GridColumn aem-GridColumn--default--12">
                    <div class="column-control-wrapper ">
                        <div class="row col-md-auto">
                            <div class="container-fluid">
                                <div class="row abs-no-gutters">

                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="slim-padding">
                                        <div class="experiencefragment section">
                                            <div *ngIf="showFrequentlyAskedQuestion"
                                                 [innerHTML]="frequentlyAskedQuestion | safeHtml"></div>
                                        </div>
                                        <div class="experiencefragment section">
                                            <div *ngIf="showTermsContent" [innerHTML]="termsContent | safeHtml"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

